import { STATSPWA_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getStats = () => {
  return myFetch(`${STATSPWA_ENDPOINT}`, "GET");
};
